export const isValidAttentionMessage = (message) => typeof message === 'string' && message.length > 0;
export const getAttentionType = ({ error, warning, success, }) => {
    if (isValidAttentionMessage(error)) {
        return 'error';
    }
    if (isValidAttentionMessage(warning)) {
        return 'warning';
    }
    if (isValidAttentionMessage(success)) {
        return 'success';
    }
    return null;
};
export const getAttentionMessage = (props, type) => {
    if (!type) {
        return null;
    }
    return props[type];
};
